import { toChildArray, ComponentChildren, VNode } from "preact";
import DropdownItem, { DropdownItemProps } from "../DropdownItem";

export default function findSelectedItem<V>(
    componentChildren: ComponentChildren
): VNode<DropdownItemProps<V>> | null {
    const childArray = toChildArray(componentChildren);

    for (const child of childArray) {
        const isChildNode = typeof child === "object";
        const isChildDropdownItem = isChildNode &&
            typeof child.type !== "string" &&
            child.type.name === DropdownItem.name;

        if (isChildDropdownItem) {
            if ((child.props as DropdownItemProps).selected) {
                // We found the selected item
                return (child as VNode<DropdownItemProps<V>>);
            }
        }

        // Keep searching the selected item inside children
        if (isChildNode && child.props && child.props.children) {
            const selectedItemInChildren = findSelectedItem<V>(toChildArray(child.props.children));
            if (selectedItemInChildren) {
                return selectedItemInChildren;
            }
        }
    }

    return null;
}
